import cn from 'classnames';
import PropTypes from 'prop-types';

import ErrorList from 'components/checkout/caap/ErrorList';
import CheckboxInput from 'components/checkout/caap/CheckboxInput';
import { toUSD } from 'helpers/NumberFormats';
import css from 'styles/components/checkout/caap/giftoptions/giftOption.scss';

export const GiftOption = (params, { testId }) => {
  const {
    charMessage,
    charMessageWarning,
    lineMessage,
    lineMessageWarning,
    price,
    giftWrapImageUrl,
    hasFormError,
    product,
    giftMessage,
    useGiftBag,
    useGiftReceipt,
    onUseGiftReceiptClick,
    onUseGiftBagClick,
    onGiftMessageChange
  } = params;
  const { image: { url: imageUrl, alt: imageAlt }, productName } = product;
  const errorList = [];
  const charWrapperClass = cn({ [css.warning]: charMessageWarning });
  const lineWrapperClass = cn({ [css.warning]: lineMessageWarning });

  if (hasFormError) {
    errorList.push('Please enter a gift message.');
  }

  const giftMessageText = useGiftBag ? 'Printed on a card attached to the gift.' : 'Printed on the gift receipt.';

  return (
    <div className={css.items} data-test-id={testId('giftOptionsContainer')}>
      <ErrorList
        errorListKey="gift"
        errorList={errorList}
        errorHeading="There was a problem" />

      <div className={css.itemSection}>
        <div className={css.image}>
          <img width="110" src={imageUrl} alt={imageAlt} />
        </div>
        <div className={css.selections}>
          <div>
            <div className={css.productName}>
              { productName }
            </div>
            <div>
              <CheckboxInput
                isChecked={!!useGiftReceipt}
                onChange={onUseGiftReceiptClick}
                name="useGiftReceipt"
                dataTestId="useGiftReceipt">
                Gift Receipt
              </CheckboxInput>
            </div>
            <div>
              <CheckboxInput
                isChecked={!!useGiftBag}
                onChange={onUseGiftBagClick}
                name="useGiftBag"
                dataTestId="useGiftBag">
                Gift Bag/Box {makePrice(price)}
              </CheckboxInput>
            </div>
          </div>
          <div className={css.giftBagImageWrapper}>
            <img src={`${giftWrapImageUrl}._SX300_.jpg`} alt="gift bag" width="150" />
          </div>
        </div>
      </div>
      <div className={css.giftMessageWrapper}>
        {
          !useGiftReceipt && <div className={css.noReceipt}>This shipment will not include any receipt and your message will not be saved.</div>
        }
        <div>Gift message:</div>
        {
          (useGiftReceipt || useGiftBag) && <div className={css.helperText}>{` (${giftMessageText})`}</div>
        }
        <textarea
          data-test-id={testId('giftMessage')}
          onChange={onGiftMessageChange}
          placeholder="Your card will be blank."
          rows="4"
          cols="40"
          value={giftMessage || ''}
          disabled={!useGiftReceipt}></textarea>
        <div className={css.counterSection}>
          <span className={charWrapperClass}>{charMessage}</span> &#8226; <span className={lineWrapperClass}>{lineMessage}</span>
        </div>
      </div>
    </div>
  );
};

export const makePrice = price => {
  if (price === 0) {
    return null;
  }

  return <span className={css.price}>+{toUSD(price)}</span>;
};

GiftOption.contextTypes = {
  testId: PropTypes.func
};

export default GiftOption;
